module.exports = __webpack_public_path__ + "908e4d2e/img/dollar-icon.35c9d638.svg";